"use client";

import React from "react";
import { sendLiveIntentRetailClickBeacon } from "helpers/Helper";

function AffiliateSectionLink({ name, book, retailer, affiliateButtonStyles }) {
  //eventLabel & eventAction declared here and inserted as data-vars to have event tracking
  let eventLabel = `${book.title} | ${book.primary_isbn} | ${book.publisher}`,
    eventAction = "Retail Click";

  const trackAffiliateClick = () => {
    const action = "Retail Click, ";
    const payload = {
      eventCategory: "Ebook",
      eventAction: `${action}${name}`,
      eventLabel: `${book.title} | ${book.primary_isbn} | ${book.publisher}`,
    };
    if (typeof window != "undefined") {
      // Preserve legacy GTM dataLayer shape (event key is "Retail Click, ", not the full eventAction)
      window.dataLayer.push({ event: action, ...payload });
      if (book.primary_isbn) {
        sendLiveIntentRetailClickBeacon(payload);
      }
    }
  };
  return (
    <a
      className={`mx-auto ${affiliateButtonStyles}`}
      rel="nofollow noopener noreferrer"
      target="_blank"
      onClick={() => trackAffiliateClick()}
      href={retailer.url}
      data-vars-event-label={eventLabel}
      data-vars-event-action={eventAction}
      data-vars-outbound-url={retailer.url}
      data-vars-outbound-text={name}
      id={`retailerbutton-${name}`}
    >
      {name}
    </a>
  );
}

export default AffiliateSectionLink;
